<div class="container mt-4" style="min-height: calc(100vh - 300px);">
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header">
                    <div class="d-flex align-items-center justify-content-between">

                        <h5 class="font-medium election-title">📄 Recovery of Audit Fees
                        </h5>
                    </div>

                </div>
                <div class="card-body">

                    <div class="row society-verify-options">
                        <form [formGroup]="challanForm">
                            <div class="row">
                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="this.UserDetails?.roleId == 1">
                                    <label class="form-label">Circle Office <span class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="circleOffice" (change)="GetBlock()">
                                        <option value="">--Select--</option>
                                        <option *ngFor="let circle of circlesList" [value]="circle?.iCircleId">
                                            {{ circle?.sCircleName }}
                                        </option>
                                    </select>
                                    <div *ngIf="challanForm.get('circleOffice')?.touched && challanForm.get('circleOffice')?.invalid"
                                        class="text-danger small">
                                        Circle office is required
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">Financial/Reporting Year <span
                                            class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="financialYear">
                                        <option value="">--Select--</option>
                                        <option *ngFor="let years of financialYears" [ngValue]="years">
                                            {{ years?.financialYear }}
                                        </option>
                                    </select>
                                    <div *ngIf="challanForm.get('financialYear')?.touched && challanForm.get('financialYear')?.invalid"
                                        class="text-danger small">
                                        Financial year is required
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div class="col-lg-12 m-0">
                            <hr>
                        </div>
                        <div class="col-lg-12 ">
                            <div class="table-responsive">
                                <table class="table table-hover table-bordered">
                                    <thead>
                                        <tr>
                                            <th>S.No.</th>
                                            <th>Month-Year</th>
                                            <th>Amount (₹)</th>
                                            <th>Societies</th>
                                            <th>Status</th>
                                            <th>Submit Date</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of filteredData; let i = index">
                                            <td>{{ i + 1 }}</td>
                                            <td>{{ item.monthYear }} </td>
                                            <td>{{ item.feeAmount ? item.feeAmount : '-' }}</td>
                                            <td>{{ item.societies ? item.societies : '0' }}</td>
                                            <td>
                                                <span class="badge rounded-pill" [ngClass]="{
              'text-bg-danger': item.status === 'Reporting Not Started',
              'text-bg-success': item.status === 'Report Submitted',
              'text-bg-warning': item.status === 'Saved Draft (Not Submitted)'
            }">

                                                    {{ item.status }}
                                                </span>

                                            </td>
                                            <td>{{ item.challanDate ? (item.challanDate | date:'dd/MM/yyyy') : '-' }}
                                            </td>
                                            <td>
                                                <div class="d-flex align-items-center gap-1">
                                                    <ng-container *ngIf="canShowButton(item)">
                                                        <button
                                                            *ngIf="!item.isFinalSubmit && !item?.isVerified && !(this.UserDetails?.roleId ==1)"
                                                            type="button" class="btn btn-info btn-sm"
                                                            (click)="editData(item)">
                                                            Edit
                                                        </button>

                                                        <button
                                                            *ngIf="!item.isFinalSubmit && !item?.isVerified && !(this.UserDetails?.roleId ==1)"
                                                            type="button" class="btn btn-primary btn-sm"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#AuditFeeChallanUploadView"
                                                            (click)="openMOdel(item)">
                                                            + Challan
                                                        </button>

                                                        <button type="button"
                                                            *ngIf="item.societies && item?.societies >0 "
                                                            class="btn btn-success btn-sm" data-bs-toggle="modal"
                                                            (click)="getDetails(item,true)"
                                                            data-bs-target="#AuditFeeReportView">
                                                            View
                                                        </button>


                                                        <button type="button" class="btn btn-success btn-sm"
                                                            title="Click to Verify"
                                                            *ngIf="this.UserDetails?.roleId ==13 && item.isFinalSubmit==1 && !item?.isVerified"
                                                            data-bs-toggle="modal" data-bs-target="#verifyConfirmModal"
                                                            (click)="setDeleteIndex(item?.id)">
                                                            <i class="bi bi-clipboard2-check"></i>
                                                        </button>
                                                        <ng-template #verifiedBlock>
                                                            <button type="button" class="btn btn-primary btn-sm"
                                                                title="Verified"
                                                                *ngIf=" item.isFinalSubmit==1 && item?.isVerified">
                                                                <i class="bi bi-lock"></i>
                                                            </button>
                                                        </ng-template>
                                                    </ng-container>

                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <!-- Delete Confirmation Modal -->
                                <div class="modal fade" id="deleteConfirmModal" tabindex="-1"
                                    aria-labelledby="deleteConfirmModalLabel" aria-hidden="true">
                                    <div class="modal-dialog">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Delete</h5>
                                                <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                            </div>
                                            <div class="modal-body">
                                                Are you sure you want to delete ?
                                            </div>
                                            <div class="modal-footer">
                                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                                    (click)="cancelDelete()">Cancel</button>
                                                <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                                                    aria-label="Close"
                                                    (click)="deleteAuditFeeRecovery(deleteIndex)">Delete</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- verify Confirmation Modal -->
                                <div class="modal fade" id="verifyConfirmModal" tabindex="-1"
                                    aria-labelledby="verifyConfirmModalLabel" aria-hidden="true">
                                    <div class="modal-dialog">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm
                                                    Verification</h5>
                                                <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                            </div>
                                            <div class="modal-body">
                                                Are you sure you want to Verify?
                                            </div>
                                            <div class="modal-footer">
                                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                                    (click)="this.deleteIndex = 0;">Cancel</button>
                                                <button type="button" class="btn btn-success" data-bs-dismiss="modal"
                                                    aria-label="Close"
                                                    (click)="verifyAuditFeeRecovery(deleteIndex)">Verify</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>



                    </div>

                </div>

                <!-- Modal -->
                <div class="modal fade" id="AuditFeeReport" data-bs-backdrop="static" data-bs-keyboard="false"
                    tabindex="-1" aria-labelledby="AuditFeeReportLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h1 class="modal-title fs-5" id="AuditFeeReportLabel">Add/Update Audit Fee
                                    Recovery Data </h1>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                                    (click)="this.hideModal('AuditFeeReport')"></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-lg-12 mb-2">
                                        <p class="m-0 text-danger" style="font-size: 12px;">Note: You are
                                            required to add challans by clicking on <b>Add Challan</b> button
                                            before adding recovery data of the society so than multiple
                                            societies can be mapped with a single Challan.<br>
                                            Adding challans does not require <b>Save Draft</b> as they are
                                            automatically saved permanently, whereas, to save Recovery Fee
                                            Data, you are required to click on <b>Save Draft</b> button after
                                            adding new rows or removing existing rows, for the changes to
                                            take effect.</p>
                                    </div>

                                    <form [formGroup]="addRecoveryForm" (ngSubmit)="submitForm()">
                                        <div class="col-lg-12">
                                            <div class="card card-body shadow-none">
                                                <div class="table-responsive">
                                                    <table class="table table-hover table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th>S.No.</th>
                                                                <th style="width: 40%;">Society</th>
                                                                <th>Fee Amount (₹)</th>
                                                                <th>Challan</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody formArrayName="recoveries">
                                                            <tr *ngFor="let row of recoveries?.controls; let i = index;  trackBy: trackByIndex"
                                                                [formGroupName]="i">
                                                                <td>{{ i + 1 }}</td>

                                                                <!-- Society Dropdown -->
                                                                <td style="width: 40%;">
                                                                    <!-- <select class="form-control" formControlName="society">
                  <option value="">--Select--</option>
                  <option *ngFor="let society of societyList" [value]="society.iSocietyDetailsId">
                    {{ society.sSocietyName }}
                  </option>
                </select> -->
                                                                    <ng-container *ngIf="row.get('societyId')">
                                                                        <!-- <ng-multiselect-dropdown
                *ngIf="societydropdownSettings && societyList "
                value=''
                  [placeholder]="'Select Society'"
                  [data]="societyList || []"
                  [settings]="societydropdownSettings || { idField: '', textField: '' }"
                  formControlName="society"
                ></ng-multiselect-dropdown> -->

                                                                        <ng-select [items]="societyList"
                                                                            bindLabel="sSocietyName"
                                                                            bindValue="iSocietyDetailsId"
                                                                            placeholder="Select Society"
                                                                            formControlName="societyId"
                                                                            [clearable]="true" 
                                                                            [appendTo]="'body'"
                                                                           style="width: 40.8333vw;z-index: 1;">
                                                                        </ng-select>

                                                                        <div *ngIf="row.get('societyId')?.touched && row.get('societyId')?.invalid"
                                                                            class="text-danger mt-1">
                                                                            <small>Society is required.</small>
                                                                        </div>
                                                                    </ng-container>
                                                                </td>

                                                                <!-- Amount -->
                                                                <td>
                                                                    <input type="text" class="form-control"
                                                                        placeholder="Amount"
                                                                        formControlName="feeAmount" />
                                                                    <div *ngIf="row.get('feeAmount')?.touched && row.get('feeAmount')?.invalid"
                                                                        class="text-danger mt-1">
                                                                        <small
                                                                            *ngIf="row.get('feeAmount')?.errors?.['required']">Amount
                                                                            is required.</small>
                                                                        <small
                                                                            *ngIf="row.get('feeAmount')?.errors?.['pattern']">Only
                                                                            numbers allowed.</small>
                                                                    </div>
                                                                </td>

                                                                <!-- Challan Dropdown -->
                                                                <td>
                                                                    <ng-container *ngIf="row.get('challanNo')">
                                                                        <!-- <ng-multiselect-dropdown
                  *ngIf="dropdownSettings && challanList"
                  [placeholder]="'Select Challan'"
                  [data]="challanList || []"
                  [settings]="dropdownSettings || { idField: '', textField: '' }"
                  formControlName="challan"
                ></ng-multiselect-dropdown> -->
                                                                        <ng-select [items]="challanList"
                                                                            bindLabel="challanNo" bindValue="challanNo"
                                                                            placeholder="Select Challan"
                                                                            formControlName="challanNo"
                                                                            [clearable]="true"
                                                                             [appendTo]="'body'">
                                                                        </ng-select>

                                                                        <div *ngIf="row.get('challanNo')?.touched && row.get('challanNo')?.invalid"
                                                                            class="text-danger mt-1">
                                                                            <small>Challan is required.</small>
                                                                        </div>
                                                                    </ng-container>
                                                                </td>

                                                                <!-- Delete Button -->
                                                                <td>
                                                                    <button type="button" class="btn btn-danger btn-sm"
                                                                        (click)="removeRecovery(i,row.get('id'))">
                                                                        <i class="bi bi-trash3"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <!-- Add Button -->
                                                <button type="button" class="btn btn-info btn-sm" style="width:200px;"
                                                    (click)="addRecovery()">
                                                    + Add Recovery Details
                                                </button>

                                                <!-- <button type="submit" class="btn btn-primary btn-sm mt-2 ms-2">
        Submit
      </button> -->
                                            </div>
                                        </div>
                                    </form>



                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                    (click)="this.hideModal('AuditFeeReport')">Close</button>
                                <button type="button" class="btn btn-secondary" (click)="submitForm()">Save
                                    Draft</button>

                                <button type="button" class="btn btn-primary" (click)="submitForm(true)">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Modal -->
                <div class="modal fade" id="AuditFeeReportView" data-bs-backdrop="static" data-bs-keyboard="false"
                    tabindex="-1" aria-labelledby="AuditFeeReportLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h1 class="modal-title fs-5" id="AuditFeeReportLabel">Audit Fee Recovery Data</h1>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                                    (click)="this.hideModal('AuditFeeReportView')"></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">


                                    <div class="col-lg-12">
                                        <div class="card card-body shadow-none">
                                            <div class="table-responsive">
                                                <table class="table table-hover table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>S.No.</th>
                                                            <th style="width: 40%;">Society</th>
                                                            <th class="text-end">Amount (₹)</th>
                                                            <th>Challan No.</th>
                                                            <th>Challan Date</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        <tr *ngFor="let item of AuditViewDetails; let i = index">
                                                            <td>{{ i + 1 }}</td>
                                                            <td style="width: 40%;">
                                                                {{ item.societyName || 'N/A' }}
                                                            </td>
                                                            <td class="text-end">
                                                                {{ item.feeAmount | number:'1.2-2' }}
                                                            </td>
                                                            <td>{{ item.challanNo || '-' }}</td>
                                                            <td>
                                                                {{ item.challanDate ? item.challanDate : '-' }}
                                                            </td>
                                                            <td>
                                                                <button type="button" class="btn btn-success btn-sm"
                                                                    title="View Challan">
                                                                    <i class="bi bi-eye-fill"
                                                                        (click)="downloadDocument(item.challanPDFPath)">
                                                                    </i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>

                                                    <tfoot *ngIf="AuditViewDetails.length">
                                                        <tr>
                                                            <th colspan="2" class="text-center">Total Amount (₹)</th>
                                                            <th class="text-end">
                                                                {{ getTotalDetailAmount() | number:'1.2-2' }}
                                                            </th>
                                                            <td colspan="3">&nbsp;</td>
                                                        </tr>
                                                    </tfoot>
                                                </table>

                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                    (click)="this.hideModal('AuditFeeReportView')">Close</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Modal -->
                <!-- Add/Update Challan Modal -->
                <div class="modal fade" id="AuditFeeChallanUploadView" data-bs-backdrop="static"
                    data-bs-keyboard="false" tabindex="-1" aria-labelledby="AuditFeeReportLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
                        <form [formGroup]="challanForm" (ngSubmit)="onSubmit()">
                            <div class="modal-content">

                                <!-- Header -->
                                <div class="modal-header">
                                    <h1 class="modal-title fs-5" id="AuditFeeReportLabel">Add / Update Audit Challan
                                    </h1>
                                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                                        (click)="[closeChallanModel()]"></button>
                                </div>

                                <!-- Body -->
                                <div class="modal-body">
                                    <div class="row">

                                        <!-- Upload Challan Section -->
                                        <div class="col-lg-12">
                                            <div class="card card-body shadow-none">
                                                <h6><b>Upload Challan</b></h6>
                                                <div class="row align-items-end">

                                                    <!-- Challan No -->
                                                    <div class="col-lg-4 col-md-6 mb-2">
                                                        <label class="form-label">
                                                            Challan No <span class="text-danger">*</span>
                                                        </label>
                                                        <input type="text" formControlName="ChallanNo"
                                                            class="form-control" placeholder="Enter Challan No">

                                                        <!-- Validation Messages -->
                                                        <div *ngIf="challanForm.get('ChallanNo')?.touched && challanForm.get('ChallanNo')?.invalid"
                                                            class="text-danger mt-1">
                                                            <small
                                                                *ngIf="challanForm.get('ChallanNo')?.errors?.['required']">Challan
                                                                No is required.</small>
                                                            <small
                                                                *ngIf="challanForm.get('ChallanNo')?.errors?.['maxlength']">Challan
                                                                No cannot exceed 20 characters.</small>
                                                        </div>
                                                    </div>

                                                    <!-- Challan Date -->
                                                    <div class="col-lg-4 col-md-6 mb-2">
                                                        <label class="form-label">
                                                            Challan Date <span class="text-danger">*</span>
                                                        </label>
                                                        <input type="date" formControlName="ChallanDate" [min]="minDate"
                                                            [max]="maxDate" class="form-control">

                                                        <!-- Validation Messages -->
                                                        <div *ngIf="challanForm.get('ChallanDate')?.touched && challanForm.get('ChallanDate')?.invalid"
                                                            class="text-danger mt-1">
                                                            <small
                                                                *ngIf="challanForm.get('ChallanDate')?.errors?.['required']">Challan
                                                                Date is required.</small>
                                                        </div>
                                                    </div>

                                                    <!-- File Upload -->
                                                    <div class="col-lg-6 col-md-12 mb-2">
                                                        <label class="form-label">
                                                            Challan PDF <span class="text-danger">*</span>
                                                            <span style="font-size: 10px;">(pdf, max 800KB)</span>
                                                        </label>
                                                        <input type="file" class="form-control" #fileInput
                                                            (change)="onFileChange($event)" accept=".pdf">

                                                        <!-- Validation Message for File -->
                                                        <div *ngIf="!uploadedFileName && challanForm.touched"
                                                            class="text-danger mt-1">
                                                            <small>Challan PDF is required.</small>
                                                        </div>
                                                    </div>

                                                    <!-- Submit Button -->
                                                    <div class="col-12 mt-2 text-end">
                                                        <button type="submit" class="btn btn-primary"
                                                            [disabled]="challanForm.invalid">+ Add Challan</button>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                        <!-- Challan List Section -->
                                        <div class="col-lg-12 mt-3">
                                            <div class="card card-body shadow-none">
                                                <h6><b>Challan List</b></h6>

                                                <div class="table-responsive">
                                                    <table class="table table-hover table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th>S.No.</th>
                                                                <th>Challan No</th>
                                                                <!-- <th class="text-end">Amount (₹)</th> -->
                                                                <th>Challan Date</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            <tr *ngFor="let item of challanList; let i = index">
                                                                <td>{{ i + 1 }}</td>
                                                                <td>{{ item.challanNo }}</td>
                                                                <!-- <td class="text-end">{{ item.Amount | number:'1.2-2' }} -->
                                                                <!-- </td> -->
                                                                <td>{{ item?.challanDate | date:'dd/MM/yyyy' }}</td>
                                                                <td>
                                                                    <div class="d-flex align-items-center gap-1">
                                                                        <button type="button"
                                                                            class="btn btn-success btn-sm"
                                                                            title="View Challan"
                                                                            (click)="downloadDocument(item.challanPDFPath)">
                                                                            <i class="bi bi-eye-fill"></i>
                                                                        </button>
                                                                        <button type="button"
                                                                            class="btn btn-danger btn-sm"
                                                                            title="Delete Challan"
                                                                            (click)="deleteChallan(item.challanId)">
                                                                            <i class="bi bi-trash3"></i>
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                            <!-- No Data Case -->
                                                            <tr *ngIf="!challanList?.length">
                                                                <td colspan="5" class="text-center text-muted">No
                                                                    Challans Found</td>
                                                            </tr>
                                                        </tbody>

                                                        <tfoot *ngIf="challanList?.length">
                                                            <tr>
                                                                <th colspan="2" class="text-center">
                                                                    <!-- Total Amount (₹) -->
                                                                </th>
                                                                <th class="text-end">
                                                                    <!-- {{ getTotalAmount() | number:'1.2-2' }} -->
                                                                </th>
                                                                <td colspan="2">&nbsp;</td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <!-- Footer -->
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                        (click)="[closeChallanModel()]">Close</button>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

